import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Contacto de emergencia (Principal)", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "primary-name"
}, "Nombre", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "primary-type"
}, "Tipo de contacto", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "primary-relationship"
}, "Parentesco", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "primary-phone1"
}, "Teléfono (1)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "primary-phone2"
}, "Teléfono (2)", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3 mt-3" }, "Contacto de emergencia (Secundario)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "secondary-name"
}, "Nombre", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "secondary-phone1"
}, "Teléfono (1)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "secondary-phone2"
}, "Teléfono (2)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_input, {
                  id: "primary-name",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.ContactPrimaryName }]),
                  modelValue: _ctx.recordProxy.ContactPrimaryName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('ContactPrimaryName', val)),
                  placeholder: "Ingrese nombre",
                  type: "text",
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                _createVNode(_component_b_form_invalid_feedback, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Campo requerido")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_b_form_input, {
                  id: "primary-type",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContactType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('ContactType', val)),
                  placeholder: "Ej: Padre, Madre, Esposo(a), Amigo(a)",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_b_form_input, {
                  id: "primary-relationship",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.Relationship,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('Relationship', val)),
                  placeholder: "Especifique el parentesco",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_b_form_input, {
                  id: "primary-phone1",
                  class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.hasAnyPrimaryPhone }]),
                  modelValue: _ctx.recordProxy.ContactPrimaryPhoneOption1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('ContactPrimaryPhoneOption1', val)),
                  placeholder: "+57 3xx xxx xxxx",
                  type: "tel"
                }, null, 8, ["modelValue", "class"]),
                _createVNode(_component_b_form_invalid_feedback, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Ingrese al menos un teléfono.")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "6",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_b_form_input, {
                  id: "primary-phone2",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContactPrimaryPhoneOption2,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('ContactPrimaryPhoneOption2', val)),
                  placeholder: "+57 3xx xxx xxxx",
                  type: "tel"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_7,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_b_form_input, {
                  id: "secondary-name",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContactSecondaryName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('ContactSecondaryName', val)),
                  placeholder: "Ingrese nombre",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_b_form_input, {
                  id: "secondary-phone1",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContactSecondaryPhoneOption1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('ContactSecondaryPhoneOption1', val)),
                  placeholder: "+57 3xx xxx xxxx",
                  type: "tel"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "6",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_b_form_input, {
                  id: "secondary-phone2",
                  class: "form-control fs-14 text-black shadow-none form-control-sm",
                  modelValue: _ctx.recordProxy.ContactSecondaryPhoneOption2,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('ContactSecondaryPhoneOption2', val)),
                  placeholder: "+57 3xx xxx xxxx",
                  type: "tel"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}